module.exports = __webpack_public_path__ + "static/media/cat.dda292fd.jpg";